'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _auditprogramresults = require('./auditprogramresults.component');

var _auditprogramresults2 = _interopRequireDefault(_auditprogramresults);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var auditprogramresultsModule = _angular2.default.module('auditprogramresults', [_angularUiRouter2.default]).component('auditprogramresults', _auditprogramresults2.default);

exports.default = auditprogramresultsModule;


// WEBPACK FOOTER //
// ./client/app/common/reports/auditprogramresults/auditprogramresults.js